import CryptoJS from "crypto-js";
import { BaseUrl } from "../BaseUrl";

export async function loginUser(dispatch, loginPayload) {

    const { UserName, Password, setloading, handleRollIdWiseDashboard, handleErrorIdWiseDashboard, setLoginmessage } = loginPayload

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/plain");

    var raw = `grant_type=password&Username=${UserName}&Password=${Password}&ApplicationType=WEB`;

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw
    };


    try {
        setloading(true)
        dispatch({ type: 'REQUEST_LOGIN' });

        let response = await fetch(`${BaseUrl}/token`, requestOptions)

        let data = await response.json();

        if (data && data.error == "Invalid Username or Password..") {
            setLoginmessage(data && data.error)
        }

        if (data && data.access_token != "") {
            dispatch({ type: 'LOGIN_SUCCESS', payload: data });
            setloading(false)
            handleRollIdWiseDashboard(data && data)

            var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), 'RangaFulan09').toString();
            try {
                // console.log('try',data)
                sessionStorage.setItem("milso", ciphertext);
                sessionStorage.setItem("A454A", data?.TableUserID);
                setloading(false)
            } catch (error) {

                setloading(false)
                console.error("Error storing data in sessionStorage", error);
            }

            return data && data[0];
        } else {
            setloading(false)
            setLoginmessage(data && data.Loginmessage)
            handleErrorIdWiseDashboard(data && data.Loginmessage)
            dispatch({ type: 'LOGIN_ERROR', error: data.Loginmessage });
            return;
        }
    }
    catch (error) {

        setloading(false)
        handleErrorIdWiseDashboard('Internal Server Error')
        dispatch({ type: 'LOGIN_ERROR', error: error });
        console.log('error');
    }
}

export async function logout(dispatch) {
    dispatch({ type: 'LOGOUT' });
    sessionStorage.removeItem('milso');
    sessionStorage.clear()
}

